const API = {
	DOMAIN: 'gallery.vphotos.cn',
	COMMON_PORXY: '//api.vphotos.cn',
	SA_SERVER_URL: 'https://sensors.vphotos.cn:8106/sa?project=vphoto_production',
	APPID: 'wx183defebc64b7a84'
};
export { API };
